import type { RootState } from 'src/app/store/types';

export function selectTripUpdateEvents(state: RootState) {
  return state.tripSummary.tripUpdateEvents;
}
